import * as Sentry from '@sentry/react';

export function initSentry(SERVER_ENV: string): void {
  const dsn = import.meta.env.VITE_SENTRY_BACKOFFICE_DSN;
  if (!dsn) return;
  if ( SERVER_ENV !== 'production' ) return; // Don't run sentry in another env than production

  Sentry.init({
    dsn,

    // Performance: traces 20% of transactions
    tracesSampleRate: 0.2,
    integrations: [Sentry.browserTracingIntegration()],
  });
}
